import React, { useEffect, useState } from "react";

import { getAllConcepts } from "../../api";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";

import { useRef } from "react";
import { FeedDetail } from "../";
import { Nodata } from "../../assets";

const Feeds = () => {
  const [{ user, mainLoader, allConcepts }, dispatch] = useStateValue();
  const effectRun = useRef();
  const [index, setIndex] = useState(20);

  useEffect(() => {
    // if (effectRun.current === true) {
    if (!allConcepts) {
      dispatch({
        type: actionType.SET_MAIN_LOADER,
        mainLoader: true,
      });
      getAllConcepts().then((data) => {
        dispatch({ type: actionType.SET_CONCEPTS, allConcepts: data.data });
      });
      setTimeout(() => {
        dispatch({
          type: actionType.SET_MAIN_LOADER,
          mainLoader: false,
        });
      }, 3000);
    }
    // }
    return () => {
      // effectRun.current = true;
    };
  }, []);
  return (
    <div className=" w-full px-6 md:px-24 flex flex-wrap items-center justify-between gap-6 gap-y-10 mt-8">
      {allConcepts ? (
        allConcepts
          .slice(0, index)
          .map((concept, i) => <FeedDetail key={i} index={i} data={concept} />)
      ) : (
        <div className="w-full flex items-center justify-center">
          <img src={Nodata} className="w-full md:w-508" alt="" />
        </div>
      )}
      {index > allConcepts?.length ? (
        <></>
      ) : (
        <>
          <div className="w-full flex items-center justify-center mt-4">
            <p
              className="px-8 py-2 rounded-full bg-primary shadow-md mb-4 cursor-pointer"
              onClick={() => setIndex(index + 20)}
            >
              Load More
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default Feeds;
